








import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Dashboard",
  components: {    
  },
})
export default class Dashboard extends Vue {
  private arianeItems = [
    { text: 'Administration', disabled: false, to: {name:'Admin'}, exact:true},
    { text: 'Dashboard', disabled: true, to: {name:'Dashboard'}},    
  ]  
}
